module.exports = "./img/6b658867fd3ab8bd21ee9996ec946369.jpg";